import RegisterPassword from './RegisterPasswordContainer';

export default RegisterPassword;